// Importing necessary hooks and components from React, Material-UI, axios, and react-router-dom
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
// Importing custom hooks, utility functions, and components
import { ResubmitSampleRequestDetails, ResubmitItemList } from ".";
import { useResubmitRequestContext, useResubmitRequest } from "./";
import {
  apiURI,
  authErrorRedirect,
  useAuthInfo,
  workingDays,
} from "../../../common";
// Importing CSS
import "../../viewRequests/frosted.css";

export function ResubmitRequestDetailsView(props) {
  // Using the context hook to access the state of the resubmit request
  const { state } = useResubmitRequestContext();
  // Using the custom hook to set the sample request details
  const { setSampleRequestDetails } = useResubmitRequest();
  // State hooks for managing the submission status and errors
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState();
  // State hook for storing the sample request ID
  const [sampleRequestID, setSampleRequestID] = useState();

  // Hook for navigation
  const history = useNavigate();
  // Hook for accessing authentication information
  const decoded = useAuthInfo();

  // Effect hook to set the sample request details and ID when the component mounts
  useEffect(() => {
    // Destructuring the request data from props
    const {
      sampleRequestID,
      date,
      dateModified,
      leadTime,
      procurementApproval,
      needByDate,
      items,
      ...requestDataRest
    } = props.requestData;
    // Updating the original items list to add requester sample image to product image
    items?.forEach((item, i) => {
      if (item.requesterSampleImage) {
        item.productImage = item.requesterSampleImage;
      } else {
        item.productImage = {
          name: item.productImage?.name,
          file: item.productImage?.file ?? "",
          sampleImageURL: "",
        };
      }
    });
    // Creating a new request data object with the needByDate adjusted for working days
    const requestData = {
      fullName: `${decoded.firstName} ${decoded.lastName}`,
      ...requestDataRest,
      items,
      needByDate: workingDays(decoded),
      businessUnit: requestDataRest.businessUnit
        ? requestDataRest.businessUnit
        : "N/A",
    };
    // Setting the sample request details and ID in the state
    setSampleRequestDetails(requestData);
    setSampleRequestID(sampleRequestID);

    // eslint-disable-next-line no-console
  }, []);

  // Function to handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    axios
      .post(`${apiURI}/form/resubmitRequest`, {
        ...state.sampleRequestDetails,
        role: decoded.role,
        sampleRequestID: sampleRequestID,
      })
      .then(() => history("/success"))
      .catch((response) => {
        console.log("error in axios form call react");
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });
    // eslint-disable-next-line no-console
  };

  errors && console.log(errors);

  // Rendering the component with the sample request details and item list
  return (
    <Grid
      container
      justifyContent="center"
      rowSpacing={4}
      columnSpacing={2}
      sx={{
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 4,
        px: 4,
        maxWidth: "100vw",
      }}
    >
      <Grid item xs={12} lg={12}>
        <ResubmitSampleRequestDetails
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
      </Grid>
      <Grid item xs={12} lg={12}>
        <ResubmitItemList />
      </Grid>
    </Grid>
  );
}
